import { Box } from "@mui/material";
import { Alert, AlertTitle } from "@mui/material";
import React from "react";
import { useIntl } from "react-intl";

export const NotFoundPage = () => {
  const { formatMessage: t } = useIntl();
  return (
    <Box>
      <Alert severity="warning">
        <AlertTitle>
          <strong>{t({ id: "notFoundLabel" })}</strong>
        </AlertTitle>
        {t({ id: "notFoundMessage" })}
      </Alert>
    </Box>
  );
};
